import React from 'react';
import styled from 'styled-components';

import { useAuthorization } from '@/core/gql/client';
import { useMePartnerLogo } from '@/core/gql/helpers/hooks';
import { SVGBrokreteLogo } from '@components/elements/icons';
import { isPartner } from '@/libs/user';
import { Link } from '@/shared/navigation';
type HeaderLogoProps = {
  className?: string;
  minimized?: boolean;
};

const HeaderLogo: React.FC<HeaderLogoProps> = ({ className, minimized }) => {
  const {
    authorization: { user }
  } = useAuthorization();

  /* fetch partner logo */
  const { logo: partnerLogo, refetch: refetchPartnerLogo } = useMePartnerLogo();
  /* show change logo form */
  const isPartnerUser = !!(user && isPartner(user?.type));

  return (
    <Root className={className} isPartner={isPartnerUser}>
      {partnerLogo && (
        <LogoContainer minimized={!!minimized} to={'/'}>
          {partnerLogo === 'default' ? (
            <div>
              <SVGBrokreteLogo />
            </div>
          ) : (
            <img src={partnerLogo} alt="" />
          )}
        </LogoContainer>
      )}
    </Root>
  );
};

const Root = styled.div<{ isPartner: boolean }>`
  user-select: none;
  cursor: ${({ isPartner }) => (isPartner ? 'pointer' : 'none')};
  width: inherit;
`;
const LogoContainer = styled(Link)<{ minimized: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: inherit;
  padding: ${props => (props.minimized ? '20px 5px' : '20px')};
  * {
    max-height: 60px;
    max-width: ${props => (props.minimized ? '40px' : '200px')};
  }
`;

export default HeaderLogo;
